import { FormControl, Validators } from '@angular/forms';

export class CustomPhone extends Validators {
    static validate(control: FormControl) {
        if (control.value && control.dirty) {
            const matches = control.value.match(/^\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})$/);
            return matches ? null : { 'invalidPhone': true };
        } else {
            return null;
        }
    }
}
